import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TrendingDown, AlertTriangle } from 'lucide-react';

export default function FailureTrendsChart({ data }) {
  if (!data?.dailyTrends || data?.dailyTrends?.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center mb-4">
          <TrendingDown className="w-6 h-6 text-red-600 mr-2" />
          <h3 className="text-lg font-semibold text-gray-900">Tendances des Échecs</h3>
        </div>
        <p className="text-gray-500 text-center py-8">Aucune donnée de tendance disponible</p>
      </div>
    );
  }

  const chartData = data?.dailyTrends?.map(day => ({
    date: day?.date,
    Succès: day?.success,
    Échecs: day?.failed,
    'Taux d\'Échec': parseFloat(day?.failureRate)
  }));

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center mb-4">
        <TrendingDown className="w-6 h-6 text-red-600 mr-2" />
        <h3 className="text-lg font-semibold text-gray-900">Tendances des Échecs (30 derniers jours)</h3>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="date" 
            angle={-45} 
            textAnchor="end" 
            height={80}
            tick={{ fontSize: 10 }}
          />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Succès" stroke="#10b981" strokeWidth={2} />
          <Line type="monotone" dataKey="Échecs" stroke="#ef4444" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>

      {/* Common Error Patterns */}
      {data?.commonErrorPatterns && data?.commonErrorPatterns?.length > 0 && (
        <div className="mt-6 pt-6 border-t border-gray-200">
          <div className="flex items-center mb-3">
            <AlertTriangle className="w-5 h-5 text-yellow-600 mr-2" />
            <h4 className="text-sm font-semibold text-gray-900">Erreurs Fréquentes</h4>
          </div>
          <div className="space-y-2">
            {data?.commonErrorPatterns?.slice(0, 5)?.map((error, index) => (
              <div key={index} className="flex items-center justify-between bg-gray-50 rounded p-2">
                <span className="text-xs text-gray-700 truncate flex-1 mr-2">{error?.pattern}</span>
                <span className="text-xs font-semibold text-red-600">{error?.count}x</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}